import {
    SET_SMART_BID_SETTINGS,
    SET_SMART_BID_SETTINGS_LOADED,
    SET_SMART_BID_SETTINGS_LOADING,
    SmartBidSettingsState,
} from '../constants/reducers/smart_bid_settings'
import { Action } from '../constants/reducers/state'

export const SmartBidSettingsInitialState: SmartBidSettingsState = {
    loading: false,
    loaded: false,
    smartBidSettings: [],
}

export const smartBidSettingsReducer = (
    state: SmartBidSettingsState,
    action: Action,
): SmartBidSettingsState => {
    if (typeof state === 'undefined') {
        return SmartBidSettingsInitialState
    }

    switch (action.type) {
        case SET_SMART_BID_SETTINGS_LOADING:
            return Object.assign({}, state, {
                loading: action.loading,
            })
        case SET_SMART_BID_SETTINGS_LOADED:
            return Object.assign({}, state, {
                loaded: action.loaded,
            })
        case SET_SMART_BID_SETTINGS:
            return Object.assign({}, state, {
                smartBidSettings: action.smartBidSettings,
            })
        default:
            return state
    }
}
